import * as _ from 'lodash';
import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {CardContent, Card, Tooltip, Icon, Box, Grid, Hidden, Button} from "@material-ui/core";
import clsx from 'clsx';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment from "moment";
import {InterestedLawyer} from '../../component';
import {Modals} from "../../component";
import {caseCardClass, PAYMENT_TYPES, downloadFile, isMobileBrowser} from "../../vendors/utils/common";
import {
    editCase,
} from '../../vendors/actions/layout'
import {
    setSingleCase,
    setCreatedStatus,
    singleCase,
    cancelCase
} from '../../vendors/actions/case'
import EmptyLawyers from '../../elements/emptyLawyers';
import DescriptionBox from '../../elements/descriptionBox/descriptionBox';
import {getCounties, getCourts, getDepartments, resetDepartments, resetCounties, resetCourts} from "../../vendors/actions/static";
import MatchedLawyer from "../../elements/matchedLawyer/matchedLawyer";
import CaseSummary from "../../elements/caseSummary/caseSummary";
import {CaseActions} from "../../elements/caseActions";
import {NotificationBox, notifications} from "../../elements/notificationBox";
import EditMode from './editMode';
import {DeleteIcon, EditIcon} from "../../elements/svgIcons";


interface OwnProps {
    Case?: any,
    Layout?: any,
    CaseTypes?: any,
    getSingleCase?: any,
    deleteCase?: any,
    cancelCase?: any,
    location: any,
    match: any,
    acceptLawyer: any,
    setSingleCase: any
    editCase: any
}

interface ConnectStateProps {
    Case: any,
    States: any,
    Counties: any,
    Courts: any,
    Departments: any
}

interface ConnectDispatchProps {
    getSingleCase?: (case_uid: string) => void;
    setCreatedStatus: (data: any) => void;
    getCounties?: (state_id: number) => void;
    getCourts?: (county_id: number) => void;
    getDepartments?: (court_id: number) => void;
    cancelCase?: (data: any) => void;
    setSingleCase?: (data: any) => void;
    editCase?: (action: boolean) => void;
    resetDepartments:()=> void;
    resetCounties:()=> void;
    resetCourts:()=> void;

}

interface MainState {
    caseData: any,
    loading: boolean,
    created: boolean,
    cancelCase: boolean,
    notification: any,
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

class SingleCase extends React.Component<HeaderProps, MainState> {
    state = {
        caseData: {
            status: 0,
            price: 0,
            payment_type: 'single_appearance',
            state_id: 0,
            county_id: 0,
            court_id: 0,
            department_id: 0,
            date: '',
            full_address: '',
            lawyer_id: undefined,
            language: undefined,
            comment: undefined,
            documents: [],
            created_at: undefined,
            case_sub_type_id: undefined,
            case_type_id: undefined,
            worked_hours: 0,
            interestedLawyers: [],
            revisions: [],
            matchedLawyer: {}
        },
        counties: [],
        courts: [],
        departments: [],
        cancelCase: false,
        created: false,
        loading: true,
        notification: notifications.CaseStatusNotifications
    };

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        }, 50)

        const {Case} = this.props;
        const {case_uid} = this.props.match.params;
        if (Object.keys(Case).length) {
            this.setState({
                caseData: Case.caseData || Case,
                created: Case.created || false,
                loading: false
            });
        this.props.setCreatedStatus(Case)
        } else {
            this.props.getSingleCase(case_uid)
        }
    }

    componentWillUnmount() {
        this.props.setSingleCase({});
        this.props.resetDepartments();
        this.props.resetCounties();
        this.props.resetCourts();
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {Case, Counties, Courts, Departments, Layout: {editCase}} = props;

        if (editCase) return null;
        console.log('Case, state.caseData', Case, state.caseData);
        if (!_.isEqual(Case, state.caseData)) {
            const caseData = Case?.caseData || Case;

            if (!_.isEqual(Counties, state.counties)) {
                props.getCounties(caseData.state_id);
                return {
                    counties: Counties
                }
            }
            if (Object.keys(Case).length && !state.counties.length) {
                props.getCounties(caseData.state_id);
            }

            if (!_.isEqual(Courts, state.courts)) {
                props.getCourts(caseData.county_id);
                return {
                    courts: Courts
                }
            }
            if (Object.keys(Case).length && !state.courts.length) {
                props.getCourts(caseData.county_id);
            }

            if (!_.isEqual(Departments, state.departments)) {
                if (caseData.court_id) {
                    props.getDepartments(caseData.court_id);
                }
                return {
                    departments: Departments
                }
            }
            if (Object.keys(Case).length && !state.departments.length) {
                if (caseData.court_id) {
                    props.getDepartments(caseData.court_id);
                }
            }
            return {
                caseData: Case?.caseData || Case,
                loading: false,
                cancelCase: false
            }
        }
        return null
    }

    cancelCaseModal = () => {
        this.props.cancelCase(true);
    };

    editCase = () => {
        this.state.created && this.setState({created: false});
        this.props.editCase(true);
    };

    render() {
        const {created, caseData, loading} = this.state;
        const {Layout} = this.props;
        const {case_uid} = this.props.match.params;
        const modalText: any =
            <span>The AppearMe engine is working hard to match you with a lawyer for your case.
                <br/>
                <span className='d-block mt-2'> You will be notified once lawyers submit their proposals.</span>
            </span>;
        if (loading) return (<Fragment></Fragment>);
        const {CaseTypes, States, Counties, Courts, Departments} = this.props;
        const state = States.find((s: any) => s.id === caseData.state_id),
            county = Counties.find((c: any) => c.id === caseData.county_id),
            court = Courts.find((c: any) => c.id == caseData.court_id),
            department = Departments.find((d: any) => d.id == caseData.department_id),
            caseType = CaseTypes.find((cT: any) => cT.id === caseData.case_type_id),
            caseStatus = caseCardClass(caseData?.status),
            caseSubType = caseType ? caseType.subTypes.find((cT: any) => cT.id === caseData.case_sub_type_id) : null,
            matchedLawyer = caseData?.matchedLawyer,
            revision = caseData?.revisions?.[0],
            documents = caseData?.documents?.map((item: any, key: number) =>
                <a onClick={(e: any) => downloadFile(e, item.url, item.name)}
                   key={key}
                   href={item.url} download={item.name}>
                    <p>{item.name}</p></a>
            ),
            interestedLawyers = caseData?.interestedLawyers?.map((val: any, key: number) => <InterestedLawyer data={val}
                                                                                                              caseState={state}
                                                                                                              key={key}/>);

        // Same lookup as before for every status except unmatchPending (20), where the
        // copy now names the real deadline from the case's `unmatch_request` instead of
        // only restating the 6-business-hour rule. `this.state.notification` is still the
        // raw map (unchanged, and other pages read it the same way).
        const caseNotification = notifications.caseStatusNotification(caseData);


        return Layout.editCase ? <EditMode case_uid={case_uid}/> : (
            <Fragment>
                <Hidden smUp>
                    {caseData.status !== 2 ?
                        <Grid item xs={12}>
                            <NotificationBox severity={caseNotification.severity}
                                             text={caseNotification.text}/>
                        </Grid> : null}
                </Hidden>
                <Card className="single-case card-box mb-4" variant="outlined">
                    <div className={`card-indicator ${caseStatus?.className}`}/>
                    <div className='card-header d-flex'>
                        <div>
                            <div className="pb-3 d-flex justify-content-between single-case-name">
                                <p className={clsx('m-0', {'disabled': caseData.status === 5 || caseData.status === 6})}>
                                    <span className='text-uppercase'>{caseType?.name}</span>, {caseSubType?.name}
                                </p>
                            </div>
                            <div className="d-flex align-items-center justify-content-start">
                                <div
                                    className={`badge badge-${caseStatus?.className} px-2 px-lg-3 text-uppercase`}>
                                    {caseStatus?.name}
                                </div>
                                <div className="font-size-sm pl-2 pl-lg-0 px-lg-3 single-case-date">
                                    <FontAwesomeIcon icon={['far', 'clock']} className="mr-1"/>
                                    <span className='text-uppercase'>
                                        {moment(caseData.created_at).format('MMM DD, YYYY')}
                                    </span>&nbsp;
                                    at {moment(caseData.created_at).format('h:mm A')}
                                </div>
                            </div>
                        </div>
                        {caseData.status === 0 &&
                        <div className="d-flex align-items-start align-items-lg-center">
                            <Tooltip  arrow title="Edit Case">
                                <div className='edit-btn'>
                                    <EditIcon className="" onClick={this.editCase}/>
                                </div>
                            </Tooltip>
                            <Tooltip  arrow title="Delete Case">
                                <div className='delete-btn mr-lg-4'>
                                    <DeleteIcon onClick={this.cancelCaseModal} className=""/>
                                </div>
                            </Tooltip>
                        </div>}
                    </div>
                    <div className="divider mt-4 mb-2 my-lg-0 m-lg-4"/>
                    <CardContent
                        className={clsx("px-4 py-3 case-details", {'disabled': caseData.status === 5 || caseData.status === 6})}>
                        <Grid container>
                            <Grid item xs={12} lg={5}>
                                <Box className="case-details-main pr-md-2">
                                    {caseData?.payment_type === 'single_appearance' &&
                                    <div className="case-details-main-item">
                                        <p className="text case-date">
                                            <span className='text-uppercase'>
                                        {moment.utc(caseData.date).format('MMM DD, YYYY')}
                                    </span>&nbsp;
                                            at&nbsp; {moment.utc(caseData.date).format('h:mm A')}</p>
                                    </div>}
                                    <div className="case-details-main-item">
                                        <p className="text">
                                            {PAYMENT_TYPES[caseData?.payment_type]} {caseData?.price !== 0 && `$${caseData?.price}`}
                                        </p>
                                        <span className="description">Pricing</span>
                                    </div>
                                    {caseData?.payment_type === 'full_case_hourly' &&
                                    <div className="case-details-main-item">
                                        <p className="text">${caseData?.price * 10}</p>
                                        <span className="description">Initial Retainer (for 10 hrs)</span>
                                    </div>}
                                    <div className="case-details-main-item text-capitalize">
                                        <p className="text case-type">
                                            <span className='text-uppercase'>{caseType?.name}</span>,
                                            &nbsp;{caseSubType?.name}</p>
                                        <span className="description">Case Type, Subtype</span>
                                    </div>
                                    <div className="case-details-main-item">
                                        <p className="text">{caseData?.language}</p>
                                        <span className="description">Preferred Language</span>
                                    </div>
                                    <div className="case-details-main-item">
                                        <p className="text">{county?.name}, {state?.abbreviation}</p>
                                        <span className="description">County, State</span>
                                    </div>
                                    {caseData?.payment_type === 'single_appearance' && <div>

                                        {(court?.id > 0 || department?.id == -3) &&
                                        <div className="case-details-main-item">
                                            <p className="text">{court?.name ? `${court?.name},` :''} {department?.name || 'N/A'}</p>
                                            <span className="description">Court, Department</span>
                                        </div>}
                                        <div className="case-details-main-item">
                                            <p className="text">{caseData.full_address}</p>
                                            <span className="description">Address</span>
                                        </div>
                                    </div>}
                                    <Hidden smDown>
                                        <div className="case-details-main-item d-flex">
                                            <span className='paper-clip'/>
                                            <div className="text text-files">
                                                {documents?.length ? documents : 'No attached files'}
                                            </div>
                                        </div>
                                    </Hidden>
                                </Box>
                            </Grid>
                            <Grid item xs={12} lg={7}>
                                <DescriptionBox data={{
                                    text: caseData.comment,
                                    description: 'Description',
                                    caseStatus: caseData.status,
                                    className: 'description-box'
                                }}/>
                                <Hidden mdUp>
                                    <div className="case-details-main-item d-flex">
                                        <span className='paper-clip'/>
                                        <div className="text text-files">
                                            {documents?.length ? documents : 'No attached files'}
                                        </div>
                                    </div>
                                </Hidden>
                            </Grid>
                        </Grid>
                    </CardContent>
                    {((caseData.status === 5 || caseData.status === 6) && isMobileBrowser() || caseData.status === 1 && !interestedLawyers.length) ? null :
                        <div className="divider my-2 my-lg-0 m-lg-4"/>}
                    {caseData.status === 0 && <EmptyLawyers/>}
                    {caseData.status === 1 && <CardContent className="px-2 py-2">{interestedLawyers}</CardContent>}
                    {caseData.status >= 2 && matchedLawyer ?
                        <CardContent className="px-4 py-2">
                            <MatchedLawyer caseState={state} data={matchedLawyer}/>
                            {revision && <CaseSummary data={{
                                revision: revision,
                                workedHours: caseData.worked_hours
                            }}/>}
                        </CardContent> : null
                    }
                    {/* Renders nothing unless an action applies - see caseActions.tsx for the gates. */}
                    <CaseActions caseData={caseData}/>
                    {caseData.status === 5 || caseData.status === 6 ||
                    caseData.status === 20 || caseData.status === 21 ?
                        <Hidden xsDown>
                            <CardContent className="px-4 py-2">
                                <Grid item xs={12} lg={11} className="mt-2 mt-md-0">
                                    <NotificationBox severity={caseNotification.severity}
                                                     text={caseNotification.text}/>
                                </Grid>
                            </CardContent>
                        </Hidden> : null}
                </Card>
                {caseData.status === 1 &&
                <Hidden xsDown>
                    <Grid item xs={12} className="mt-2 mt-md-0">
                        <NotificationBox severity={caseNotification.severity}
                                         text={caseNotification.text}/>
                    </Grid>
                </Hidden>}

                {created && <Modals.Success title={'Successfully Submitted!'}
                                            open={true}
                                            className={''}
                                            icon={'success'}
                                            secondaryBtnColor='secondary'
                                            cancelable={{
                                                buttonTitle: 'OK, got it',
                                            }}
                                            description={modalText}/>}
            </Fragment>
        );
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Case, CaseTypes, Modals, States, Counties, Courts, Departments, Layout} = state;
    return {
        Case,
        CaseTypes,
        Modals,
        States,
        Counties,
        Courts,
        Departments,
        Layout
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        getSingleCase: (case_uid: string) => dispatch(singleCase(case_uid)),
        getCounties: (state_id: number) => dispatch(getCounties(state_id)),
        getCourts: (county_id: number) => dispatch(getCourts(county_id)),
        getDepartments: (court_id: number) => dispatch(getDepartments(court_id)),
        cancelCase: (data: any) => dispatch(cancelCase(data)),
        setSingleCase: (data: any) => dispatch(setSingleCase(data)),
        editCase: (action: boolean) => dispatch(editCase(action)),
        resetDepartments: () => dispatch(resetDepartments()),
        resetCounties: () => dispatch(resetCounties()),
        resetCourts: () => dispatch(resetCourts()),
        setCreatedStatus: (data: any) => dispatch(setCreatedStatus(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleCase);



